// The dashboard charts as lazy components, so Recharts loads in its own chunk after the page.
import { type ComponentProps, lazy, Suspense } from "react";

const load = () => import("./charts");
const LazyCapacity = lazy(() => load().then((m) => ({ default: m.CapacityChart })));
const LazySpend = lazy(() => load().then((m) => ({ default: m.SpendBars })));
const LazySpark = lazy(() => load().then((m) => ({ default: m.Sparkline })));
const LazyPaid = lazy(() => load().then((m) => ({ default: m.PaidSpendBars })));

type Props<K extends keyof Awaited<ReturnType<typeof load>>> = ComponentProps<Awaited<ReturnType<typeof load>>[K]>;

export function CapacityChart(props: Props<"CapacityChart">) {
  return (
    <Suspense fallback={null}>
      <LazyCapacity {...props} />
    </Suspense>
  );
}

export function SpendBars(props: Props<"SpendBars">) {
  return (
    <Suspense fallback={null}>
      <LazySpend {...props} />
    </Suspense>
  );
}

export function PaidSpendBars(props: Props<"PaidSpendBars">) {
  return (
    <Suspense fallback={null}>
      <LazyPaid {...props} />
    </Suspense>
  );
}

export function Sparkline(props: Props<"Sparkline">) {
  return (
    <Suspense fallback={null}>
      <LazySpark {...props} />
    </Suspense>
  );
}
